import { useMemo } from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import { type RovoSkillsConfig } from '@atlassian/rovo-skills/services/rovo-skills-config-provider';

import { areStringArraysEqual } from './areStringArraysEqual';
import { type ConversationAssistantProps } from './types';
import { useSemanticStableValue } from './useSemanticStableValue';

const areRovoSkillTagsEqual = (
	current?: ConversationAssistantProps['tags'],
	next?: ConversationAssistantProps['tags'],
): boolean => areStringArraysEqual(current?.skillRegistryTags, next?.skillRegistryTags);

export const useRovoSkillsProviderConfig = ({
	tags,
}: {
	tags?: ConversationAssistantProps['tags'];
}): RovoSkillsConfig => {
	const isTreatmentEnabled =
		FeatureGates.getExperimentValue<boolean>(
			'rovo_ttai_segment_render_stabilization',
			'isEnabled',
			false,
		) === true;
	const stableTags = useSemanticStableValue(tags, isTreatmentEnabled, areRovoSkillTagsEqual);
	const memoizedRovoSkillsConfig: RovoSkillsConfig | undefined = useMemo(
		() => (isTreatmentEnabled ? { tags: stableTags } : undefined),
		[isTreatmentEnabled, stableTags],
	);

	if (memoizedRovoSkillsConfig) {
		return memoizedRovoSkillsConfig;
	}

	return { tags };
};
